import Tracker from "../prop-trackers/tracker.js";
import DictTracker from "../prop-trackers/dict-tracker.js";

const EmptySet = new Set();

class ConsumingDictMux extends Tracker {
    constructor(sourceTracker, keyTracker, userdata) {
        super();

        this._sourceTracker = sourceTracker;
        this._keyTracker = keyTracker;

        this._keyElements = new Map();

        const needsUpdate = () => this.protected_needsUpdate();
        sourceTracker.listenNeedsUpdate(needsUpdate);
        keyTracker.listenNeedsUpdate(needsUpdate);

        this._outputTracker = new DictTracker(userdata);
    }

    protected_startUpdate() {
        this._sourceTracker.update(({ props: sourceProps }) => {
            this._keyTracker.updateIfNeeded(({ props: keyProps }) => {
                for (const { key: element, oldValue: oldKey, newValue: newKey } of keyProps.iterateModified()) {
                    if (typeof oldKey === "string") {
                        const elements = this._keyElements.get(oldKey);
                        elements.delete(element);

                        if (elements.size === 0) {
                            this._keyElements.delete(oldKey);
                        }
                    }

                    if (typeof newKey === "string") {
                        let elements = this._keyElements.get(newKey);

                        if (!elements) {
                            elements = new Set();
                            this._keyElements.set(newKey, elements);
                        }

                        elements.add(element);

                        const { newExists, newValue } = sourceProps.get(newKey);

                        if (newExists) {
                            this._outputTracker.setValue(element, newValue);
                        } else {
                            this._outputTracker.deleteValue(element);
                        }
                    } else {
                        this._outputTracker.deleteValue(element);
                    }
                }
            });

            for (const { key, newExists, newValue } of sourceProps.iterateModified()) {
                const elements = this._keyElements.get(key) || EmptySet;

                for (const element of elements) {
                    if (newExists) {
                        this._outputTracker.setValue(element, newValue);
                    } else {
                        this._outputTracker.deleteValue(element);
                    }
                }
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default ConsumingDictMux;
